import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 px-4 grid-lines">
      <div className="w-full max-w-md border border-white/10 bg-zinc-900/70 backdrop-blur p-8">
        <div className="font-mono-data text-xs text-lime-400 tracking-widest mb-2">— ACCESSO TERMINALE</div>
        <h1 className="font-display font-black text-3xl mb-6">Bentornato.</h1>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="font-mono-data text-xs tracking-widest text-zinc-400">EMAIL</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-none bg-zinc-950 border-white/10 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 h-11"
              data-testid="input-email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="font-mono-data text-xs tracking-widest text-zinc-400">PASSWORD</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="rounded-none bg-zinc-950 border-white/10 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 h-11"
              data-testid="input-password"
            />
          </div>
          {error && (
            <div className="border border-red-500/40 bg-red-500/10 text-red-300 text-sm p-3 font-mono-data" data-testid="login-error">
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={busy}
            className="w-full rounded-none bg-lime-400 text-lime-950 hover:bg-lime-500 font-bold h-11"
            data-testid="btn-login-submit"
          >
            {busy ? "Accesso in corso..." : "Accedi →"}
          </Button>
        </form>

        <div className="mt-6 text-sm text-zinc-500 text-center">
          Nessun account? {" "}
          <Link to="/register" className="text-lime-400 hover:underline" data-testid="link-register">
            Registrati
          </Link>
        </div>
        <div className="mt-4 text-[11px] text-zinc-600 font-mono-data text-center">
          demo: admin@immo.it / admin123
        </div>
      </div>
    </div>
  );
}
